/*
 * zh-cn locale
 * @ignore
 * @author yiminghe@gmail.com
 */
"use strict";

module.exports = {
  // in minutes
  timezoneOffset: 8 * 60,
  firstDayOfWeek: 1,
  minimalDaysInFirstWeek: 1
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/gregorian-calendar/lib/locale/zh_CN.js
 ** module id = 85
 ** module chunks = 0
 **/